module.exports = __webpack_public_path__ + "static/img/act-1.9116b8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/act-1.png
// module id = 4bX2
// module chunks = 5